import { datadogRum } from "@datadog/browser-rum-slim";
import Script from "next/script";

export default function Scripts() {
  const datadogEnabled = process.env.NEXT_PUBLIC_DATADOG_ENABLED === "true";

  if (datadogEnabled) {
    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: "datadoghq.com",
      service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
      env: process.env.NEXT_PUBLIC_DATADOG_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: process.env.NEXT_PUBLIC_APP_VERSION || "development",
      sessionSampleRate: 10,
      sessionReplaySampleRate: 0,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [/.*.dines\.co\.uk/gi],
      proxy: `${process.env.BASE_URL}/api/datadog/proxy`,
    });
  }
  return (
    <>
      <script
        // biome-ignore lint/security/noDangerouslySetInnerHtml: Fine here for HelpScout Beacon
        dangerouslySetInnerHTML={{
          __html: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`,
        }}
      />
      <Script id="myfonts" src="https://hello.myfonts.net/count/3c3f79" async />
    </>
  );
}
